<template lang="pug">
  .cover-page-container
    #cover-page.costera-page
      .layout.row.cover-header.wrap
        .flex.offset-md7.md8.xs12.title-program
          span ASU COSTERA
      LineMultiColorHeaderSeparator
      .layout.row.cover-body.wrap
        .flex.md4
          .logoprogram
            img.asuparticipa-logo(src="@/assets/img/asucostera.png")
            h3.logoprogram-title El proyecto forma parte del <strong><a href="/documents/PLAN_MAESTRO_FRANJA_COSTERA_2017.pdf" class="sub" target="_blank">Plan Maestro de la Franja Costera.</a></strong> <strong>- ASU VIVA.</strong>
            .information
              router-link( :to="{ name: 'asudownload', params: { page: 'costera' } }") Ver más información
        .flex.md8
          .description
            .description-header.center
              i.comillas.ap-comilla1
              h1.programs-page-title Un <strong>proyecto</strong> que inició hace más de 25 años, y hoy es un
                <strong>plan</strong> que integra la <strong>ciudad con la costa</strong>, desde lo <strong>social</strong>,
                <strong>ambiental</strong> y <strong>urbano</strong>.
              i.comillas.ap-comilla2
          .description-body
            h2 En esta plataforma se presentan proyectos del Plan Maestro de la Franja
              | Costera de Asunción (i.e. infraestructura, espacios públicos, barrios sociales
              | nuevos, consolidación de barrios, urbanización privada), que son vistos como
              | la solución definitiva a la inundación de las costas de Asunción.<br><br>
            h2 Los proyectos son responsabilidad de los entes planificadores y/o ejecutores,
              | AsuParticipa sólo promueve el acceso a la información sobre estos proyectos.
    Footer
</template>
<script>
import goToHomeMixin from '@/mixins/go-back-home.js'

export default {
  mixins: [ goToHomeMixin ]
}
</script>
<style scoped lang="stylus">
@import '~@/styles/variables'

.cover-page-container
  margin: 100px 0 0 0

#cover-page
  .logoprogram img
    margin-top: -75px

  .logoprogram-title
    margin-top: -95px

  .description-body
    margin: 0 4rem;

</style>
